<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <SectionTemplate
        v-if="!loading && items.length"
        class="d-flex flex-column team-section"
        :title="title"
      >
        <div class="mt-12 grid-list">
          <template v-for="(item, keyItems) in items">
            <TeamCard :key="keyItems" v-bind="item" />
          </template>
        </div>
      </SectionTemplate>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import SectionTemplate from "../templates/SectionTemplate.vue";
import TeamCard from "../cards/TeamCard.vue";

const _config = {
  mod: "team",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    items: [],
  }),
  props: {
    title: {
      type: String,
      default: "Consultores",
    },
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$rest(_config.mod)
        .get()
        .then((data) => {
          this.items = data;
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    LoadingWidget,
    SectionTemplate,
    TeamCard,
  },
};
</script>

<style lang="scss" scoped>
.team-section::v-deep {
  width: 100%;

  .title-widget {
    &:before,
    &:after {
      background-color: var(--v-warning-darken4);
    }
  }
}

.grid-list {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 1264px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}
</style>
